
import { defineComponent, PropType } from 'vue'
import { ListItemsNavBar } from '@/config/variables'
import { goToElement } from '@/use/navigation'
import { theme } from '@/config/styles'

export interface IitemsNavBar {
    title: string
    href: string
}

const __default__ = defineComponent({
    props: {
        listItems: {
            type: Object as PropType<IitemsNavBar[]>,
            default: ListItemsNavBar,
        },
    },
    setup() {
        return {
            goToElement,
            theme,
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7f1ff0ae": (_ctx.theme.colors.primary.midlight),
  "0e1bc396": (_ctx.theme.colors.white)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__